const normalizeBaseUrl = (value?: string) => value?.trim().replace(/\/+$/, '') || '';

const apiBaseUrl = normalizeBaseUrl(window.API_BASE_URL);

export const runtimeConfig = {
  apiBaseUrl,
  graphqlUrl: apiBaseUrl ? `${apiBaseUrl}/graphql` : '/graphql',
  restApiUrl: apiBaseUrl ? `${apiBaseUrl}/api/v1` : '/api/v1',
};
